import React from 'react';

function Tenders() {
  const banks = [
    { name: 'Сбербанк', accounts: 'казначейские счета для 44-ФЗ, 223-ФЗ', url: 'https://www.sberbank.ru/ru/legal/tenders' },
    { name: 'ВТБ', accounts: 'спецсчета для госзакупок, гарантии', url: 'https://www.vtb.ru/business/tendery/' },
    { name: 'ПСБ', accounts: 'казначейское сопровождение ГОЗ', url: 'https://www.psbank.ru/Business/Treasury' },
  ];

  const platforms = [
    { name: 'Сбербанк-АСТ', url: 'https://www.sberbank-ast.ru' },
    { name: 'РТС-тендер', url: 'https://www.rts-tender.ru' },
    { name: 'ЕЭТП (Росэлторг)', url: 'https://www.roseltorg.ru' },
    { name: 'ЭТП ГПБ', url: 'https://etp.gpb.ru' },
    { name: 'НАЭТ (TEK-Torg)', url: 'https://www.tektorg.ru' },
  ];

  return (
    <div>
      <h2>Tenders & Treasury Accounts</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Opening treasury accounts for government procurement (44-FZ, 223-FZ, 615-PP)
      </p>

      <div style={{ marginBottom: 20, padding: 14, background: '#1E293B', borderRadius: 8, border: '1px solid #334155' }}>
        <h3 style={{ marginBottom: 8 }}>How to participate in tenders</h3>
        <ol style={{ color: '#94A3B8', fontSize: 13, paddingLeft: 20 }}>
          <li style={{ marginBottom: 4 }}>Get an electronic signature (UKEP)</li>
          <li style={{ marginBottom: 4 }}>Register on a trading platform</li>
          <li style={{ marginBottom: 4 }}>Open a treasury account at a bank</li>
          <li style={{ marginBottom: 4 }}>Deposit bid security (0.5–5% of contract)</li>
          <li>Submit your bid and participate</li>
        </ol>
      </div>

      <h3 style={{ marginBottom: 10 }}>Banks with Treasury Accounts</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 20 }}>
        <thead>
          <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
            <th style={{ padding: 8 }}>Bank</th>
            <th style={{ padding: 8 }}>Services</th>
            <th style={{ padding: 8 }}>Link</th>
          </tr>
        </thead>
        <tbody>
          {banks.map((b, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 8 }}>{b.name}</td>
              <td style={{ padding: 8, color: '#94A3B8' }}>{b.accounts}</td>
              <td style={{ padding: 8 }}>
                <a href={b.url} target="_blank" rel="noopener noreferrer" style={{ color: '#6366F1', textDecoration: 'none' }}>
                  Open →
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 style={{ marginBottom: 10 }}>Trading Platforms</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
            <th style={{ padding: 8 }}>Platform</th>
            <th style={{ padding: 8 }}>Link</th>
          </tr>
        </thead>
        <tbody>
          {platforms.map((p, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 8 }}>{p.name}</td>
              <td style={{ padding: 8 }}>
                <a href={p.url} target="_blank" rel="noopener noreferrer" style={{ color: '#6366F1', textDecoration: 'none' }}>
                  Go to platform →
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Tenders;